var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_vm._m(0),_c('span',{staticClass:"notice-content"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-title flex-startCenter"},[_c('i',{staticClass:"el-icon-warning-outline font18 color-orange margin-right5"}),_vm._v(" 重要提示： ")])
}]

export { render, staticRenderFns }